function TimelineElement({ data, timeline }) {
  let statut = "✅ Validé";
  if (data.statut == "en cours") statut = "🕑 En cours";
  if (data.statut == "non") statut = "❌ Non validé";

  return (
    <section style={{ width: data.width + "%", left: data.start + "%" }}>
      <div className="content">
        <h3>{data.nom}</h3>
        <p>{statut}</p>
        <p>
          {data.école} • {data.lieux}
        </p>
      </div>
      <div className="dates">
        <p>{data.date.split("-")[0]}</p>
        <p>
          {data.date.split("-")[1] == ""
            ? new Date().getFullYear()
            : data.date.split("-")[1]}
        </p>
      </div>
    </section>
  );
}

export default TimelineElement;
